import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';
import BottomNav from './components/BottomNav';
import SignIn from './pages/SignIn';
import Home from './pages/Home';
import DebtListPage from './pages/DebtListPage';
import Analytics from './pages/Analytics';
import Subscriptions from './pages/Subscriptions';
import SpendingTracker from './pages/SpendingTracker';
import BankAccountsPage from './pages/BankAccountsPage';
import MonthlyForecast from './pages/MonthlyForecast';
import ProtectedRoute from './components/ProtectedRoute';

// Wrapper to conditionally show BottomNav (not on signin)
const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const showBottomNav = location.pathname !== '/signin' && location.pathname !== '/';

  return (
    <>
      {children}
      {showBottomNav && <BottomNav />}
    </>
  );
};

function App() {
  return (
    <Router>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { background: '#1a1a2e', color: '#fff', border: '1px solid rgba(255,255,255,0.1)' },
          success: { duration: 3000, iconTheme: { primary: '#10b981', secondary: '#fff' } },
          error: { duration: 5000, iconTheme: { primary: '#ef4444', secondary: '#fff' } },
        }}
      />
      <AppLayout>
        <Routes>
          {/* Redirect root to signin */}
          <Route path="/" element={<Navigate to="/signin" replace />} />

          {/* Auth */}
          <Route path="/signin" element={<SignIn />} />

          {/* Protected routes */}
          <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/bank-accounts" element={<ProtectedRoute><BankAccountsPage /></ProtectedRoute>} />
          <Route path="/my-debts" element={<ProtectedRoute><DebtListPage /></ProtectedRoute>} />
          <Route path="/subscriptions" element={<ProtectedRoute><Subscriptions /></ProtectedRoute>} />
          <Route path="/spending" element={<ProtectedRoute><SpendingTracker /></ProtectedRoute>} />
          <Route path="/forecast" element={<ProtectedRoute><MonthlyForecast /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/signin" replace />} />
        </Routes>
      </AppLayout>
    </Router>
  );
}

export default App;